import { buildNavigationUrl } from "../../../util/buildNavigationUrl";
const buildInvoiceNavigationTargetUrl = ({
  activeSubPage = "details",
  listContext = {},
  recordId,
  status = "all",
} = {}) => {
  const query = new URLSearchParams(listContext.locationSearch || "");
  if (status === "all") query.delete("status");
  else if (status) query.set("status", status);
  return buildNavigationUrl(`/invoice/${recordId}/${activeSubPage}`, query);
};

export { buildInvoiceNavigationTargetUrl };
